module.exports = __webpack_public_path__ + "img/logo.d62e6785.svg";